<div class="ant-alert ant-alert-info ant-alert-with-description">
  <i class="ant-alert-icon anticon anticon-read"></i>
  <span class="ant-alert-message">
    {{title}}
    <span class="nrml" *ngIf="toggleFor=='exclusions'">
      <a *ngIf="!isToggledOpen" (click)="toggle()">View</a>
      <a *ngIf="isToggledOpen" (click)="closetoggle()">Close</a>
    </span>
    <span class="nrml" *ngIf="toggleFor=='tAndc'">
      <a *ngIf="!isTermsConditionsToggleOpen" (click)="toggleTandC()">View</a>
      <a *ngIf="isTermsConditionsToggleOpen" (click)="closetoggleTandC()">Close</a>
    </span>


  </span>
  <div *ngIf="toggleFor=='exclusions'">
    <div class="ant-alert-description ani-all-025-ease scrolla" *ngIf="isToggledOpen">
      <p *ngFor="let item of exclusionsList;let i = index">{{i + 1}}. {{item?.remarks}}</p>
    </div>
  </div>
  <div *ngIf="toggleFor=='tAndc'">
    <div class="ant-alert-description ani-all-025-ease scrolla" *ngIf="isTermsConditionsToggleOpen">
      <div *ngFor="let item of termConditionData;let i = index" [innerHTML]="item.termAndCondition"></div>
    </div>
  </div>
  <div class="p-t-10 d-b">
  </div>
</div>